module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "epub:type": "toc",
      "id": "table-of-contents",
      "role": "doc-toc"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("Contents")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Ghosts, Easter, and Other Things")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Am I Dead?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("3. ")]), _c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Bully is Scared")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("4. ")]), _c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Kyle’s Secret")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("5. ")]), _c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Inconvenience of High School")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("6. ")]), _c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Body")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("7. ")]), _c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Uncle Freddie")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("8. ")]), _c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Not James")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("9. ")]), _c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Demon Makes a House Call")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("10. ")]), _c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("To Grandma’s House We Go")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("11. ")]), _c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Wilby’s in the Know")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("12. ")]), _c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("A Prince of a Demon")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("13. ")]), _c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Sanctity of Family")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("14. ")]), _c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("What’s East is West")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("15. ")]), _c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("A Visit from an Old Friend")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("16. ")]), _c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Meet the Devil")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("17. ")]), _c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Witch’s Blood")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("18. ")]), _c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("After the Hurricane")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("19. ")]), _c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Prom")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("About the Author")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0